// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3o96t","description":"PatientConsentPreview_description__JD97Q"};